module.exports = __webpack_public_path__ + "static/door-flowers-zoom-414fa14721ffa59546c58a1253f33441.jpg";